module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('img', {
    staticClass: "qrcode"
  }), _vm._v(" "), _c('div', {
    staticClass: "foot_item",
    staticStyle: {
      "margin-left": "180px"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("关于返猪")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("公司介绍")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("加入我们")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("企业历程")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("最新动态")])]), _vm._v(" "), _c('div', {
    staticClass: "foot_item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("用户服务")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("意见反馈")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("返猪协议")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("审查规范")])]), _vm._v(" "), _c('div', {
    staticClass: "foot_item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("产品与服务")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("网站建设")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("微信营销")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("建站快车")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("在线商城")])]), _vm._v(" "), _c('div', {
    staticClass: "foot_item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("商务合作")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("加盟返猪")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("平台合作")])]), _vm._v(" "), _c('div', {
    staticClass: "company",
    attrs: {
      "onclick": "window.open('https://beian.miit.gov.cn')"
    }
  }, [_vm._v("江西聚小宝科技有限公司©2008-2020 赣ICP 备19013683 号")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3eba04af"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer.vue
// module id = 22
// module chunks = 0